/** @format */

import { tariffConstants } from './actions';
import { notificationConstants } from '../notifications/notifications';
import { reducerDebug } from '../../core/debug';
import TariffInterface, { TariffCollectionInterface } from '../../interfaces/billing/TariffInterface';

export type TariffReducersType = {
    type: string;
    collections?: TariffCollectionInterface;
    item?: TariffInterface;
    data?: TariffInterface;
    success?: boolean;
    deletedSuccess?: boolean;
    message?: string;
    selectedValue?: string | number;
    valueChange?: boolean;
};

export function tariffsReducers(state = {}, action: TariffReducersType): object {
    reducerDebug('Tariffs reducer: ' + action.type);
    switch (action.type) {
        case tariffConstants.LIST:
        case tariffConstants.ITEM:
        case tariffConstants.ADD:
        case tariffConstants.EDIT:
        case tariffConstants.DELETE:
        case tariffConstants.SELECT:
        case notificationConstants.ERROR:
            return {
                ...state,
                ...action,
            };
        default:
            return {
                ...state,
                success: false,
                deletedSuccess: false,
            };
    }
}
